import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import seal from '../../../images/LAPELS-LOLA-Logo.png'
import React, { useState } from 'react';
import IndividualForm from './IndividualForm';
import FirmForm from './FirmForm';
import { Col, Row } from 'react-bootstrap';
import { Form, Radio, RadioGroup } from 'rsuite';

function RegisterNewMemberForm(props) {
    const [radioState, setRadioState] = useState('individual');
    const imageStyle = {
        height: '10rem',
        width: '10rem',
        margin: 'auto'
    };
    const centerText = {
        textAlign: 'center'
    }

    const handleSubmitClick = () => {
    }
    return (
        <Card style={{ width: '55rem', paddingTop: '1rem' }}>
            <br />
            <Card.Img variant="top" src={seal} alt="Lapels Seal" style={imageStyle} />
            <Card.Body>
                <Card.Title style={centerText}>Apply for a new license</Card.Title>
                <div className="container">

                    <Row>
                        <Col>
                            <Form.Group>
                                <RadioGroup className="justify-content-center" name="radioState" value={radioState} onChange={state => { setRadioState(state) }} inline>
                                    <Radio tabindex="0" value="individual">Individual</Radio>
                                    <Radio tabindex="0" value="firm">Firm</Radio>
                                </RadioGroup>
                            </Form.Group>
                        </Col>
                    </Row>

                    {radioState === 'individual' && <IndividualForm />}
                    {radioState === 'firm' && <FirmForm />}



                    <br />
                    <div className="row justify-content-center">
                        <Button variant="primary" type="submit" onClick={handleSubmitClick} form={radioState + 'Form'}>Register</Button>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
}
export default RegisterNewMemberForm;

